import ast from './ast';
import { common } from '@tencent/ceiba-base-components';
import { filterUrlParamsFunc } from './fliterUrlParams';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';
import Vue from 'vue';

export default {
  components: { [CDialog.name]: CDialog },
  initTgclubTopbar(meta) {
    console.log('initTgclubTopbar======================meta=', meta);
    console.log('reportClickRawbeforeCloseAction', this);

    /**
     * 判断APP版本是否大于等于给定版本
     * @param {string[]} criticality 给定版本 如 ['5', '8', '4']
     */
    function appVersion(criticality) {
      if (typeof (criticality) !== 'object') {
        return false;
      }
      let str = navigator.userAgent.toLowerCase();
      if (str.match('tgclub') === null) {
        return false;
      }
      str = str.substr(str.indexOf('tgclub/') + 7, 12);
      const versionArr = str.split('.');
      if (+versionArr[0] > +criticality[0]) {
        return true;
      }
      if (versionArr[0] === criticality[0] && +versionArr[1] > +criticality[1]) {
        return true;
      }
      if (versionArr[0] === criticality[0] && versionArr[1] === criticality[1]) {
        if (!(/ipad|iphone|ipod/ig.test(navigator.userAgent.toLowerCase()))) {
          if (parseInt(versionArr[2], 10) >= criticality[2]) {
            return true;
          }
          return false;
        }
        const helpArr = versionArr[2].split(' ');
        if (parseInt(helpArr[0], 10) >= criticality[2]) {
          return true;
        }
        return false;
      }
      return false;
    }

    function getDevice() {
      const u = navigator.userAgent;
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
      if (isAndroid) return 'android';
      if (isiOS) return 'ios';
      return 'android'; // 默认安卓
    }

    window.cleanCallback = () => {
      beforeCloseActionDialog.style.display = 'block';
      console.log('reportClickRaw.typeof Vue.prototype', typeof Vue.prototype?.$storeInstance?._actions?.reportClickRaw[0] === 'function');
      // 弹框显示 埋点上报
      if (typeof Vue.prototype?.$storeInstance?._actions?.reportClickRaw[0] === 'function') {
        const params = {
          // ceibaComponentId: `${this.cid}`,
          // ceibaComponentUid: this.uid,
          ceibaComponentUname: '挽留弹框曝光',
          eventKey: 'dialog_expose',
          eventData: {
            stage: 2,
          },
        };
        console.log('reportClickRaw.params', params);
        Vue.prototype?.$storeInstance?._actions?.reportClickRaw[0](params);
      }
    };

    function addTgclubJsApiCallback(apiName) {
      let platform = 'browser';
      const ua = navigator.userAgent;
      if (ua.match(/MicroMessenger/i)) platform = 'wx';
      else if (ua.match(/tgclub/i)) platform = 'tgclubApp';
      else if (ua.match(/QQ\/[0-9]/i)) platform = 'qq';
      console.log('TgclubJsApiRequireVersion.platform', platform);
      console.log('TgclubJsApiRequireVersion.apiName', apiName);
      if (platform === 'tgclubApp' && appVersion(['5', '8', '5'])) {
        const run = () => {
          console.log('TgclubJsApiRequireVersion.run');
          window.Tgclub[apiName]('function(){window.cleanCallback()}');
        };
        const iosRun = () => {
          console.log('TgclubJsApiRequireVersion.iosRun');
          window.Tgclub[apiName](() => {
            window.cleanCallback();
          });
        };
        if (window.Tgclub) {
          console.log('TgclubJsApiRequireVersion.TgclubReady', 4545);
          run();
        } else {
          console.log('TgclubJsApiRequireVersion.TgclubReady', 1212);
          // document.addEventListener('TgclubReady', run);
          window.document.addEventListener(
            'TgclubReady',
            iosRun,
            true,
          );
        }
      } else {
        const msg = `非APP或者app版本不支持${apiName}`;
        console.warn(msg);
      }
    }

    // 获取当前周  周末的时间戳
    function getTimeStr() {
      const nowData = new Date();
      let currentDay = nowData.getDay();
      if (currentDay === 0) {
        currentDay = 7;
      }
      const sunDayTime = nowData.setHours(23, 59, 59) + (7 - currentDay) * 24 * 60 * 60 * 1000;
      return sunDayTime;
    }

    // 设置频率
    function getFrequency() {
      // 本地缓存key
      const key = `beforeCloseActionFrequency12${common.tool.getCookie('openid') || common.tool.getCookie('uin')}`;
      let val = window.localStorage.getItem(key);
      console.log('TgclubJsApiRequireVersion.getFrequency', key);
      // 如果没有值就直接返回null
      if (!val) {
        return true;
      }
      // 存在
      val = JSON.parse(val);
      console.log('TgclubJsApiRequireVersion.getFrequency', val);
      // 已满三次
      if (val.value >= 3) {
        return false;
      }
      const nowTimeStr = new Date().getTime();
      // 本周已弹
      if (nowTimeStr <= parseInt(val.time, 10)) {
        return false;
      }
      return true;
    }

    function setFrequency() {
      // 本地缓存key
      if (!common.tool.getCookie('openid')) {
        return;
      }
      const key = `beforeCloseActionFrequency12${common.tool.getCookie('openid')}`;
      let val = window.localStorage.getItem(key);
      console.log('TgclubJsApiRequireVersion.setFrequency', key);
      // 如果没有值就直接返回null
      if (!val) {
        const obj = {
          value: 1, // 存储值
          time: getTimeStr(), // 存值的比较时间戳
        };
        console.log('TgclubJsApiRequireVersion.setFrequency', obj);
        window.localStorage.setItem(key, JSON.stringify(obj));
      } else {
        // 存在
        val = JSON.parse(val);
        console.log('TgclubJsApiRequireVersion.setFrequency', val);
        // 未满三次
        // 本周已更新记录  无需再去记录
        const nowTimeStr = new Date().getTime();
        if (nowTimeStr <= parseInt(val.time, 10)) {
          return;
        }
        const obj = {
          value: val.value + 1, // 存储值
          time: getTimeStr(), // 存值的比较时间戳
        };
        console.log('TgclubJsApiRequireVersion.setFrequency', obj);
        window.localStorage.setItem(key, JSON.stringify(obj));
      }
    }
    // 返回对象
    function getUrlVars(url) {
      const vars = {};
      url.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
        vars[key] = value;
      });
      return vars;
    }
    // 获取url后的参数
    const oUrl = window.location.href;
    console.log(getUrlVars(oUrl));

    // 插入样式
    const beforeCloseActionStyle = document.createElement('style');
    beforeCloseActionStyle.type = 'text/css';
    beforeCloseActionStyle.innerHTML += '.beforeCloseAction{display:none;height: 100vh;width: 100%;position:fixed;top:0;left:0;z-index:9999;background:rgba(0,0,0,0.5)}';
    beforeCloseActionStyle.innerHTML += '.beforeCloseAction .beforeCloseActionPop{height: 5.44rem;width:6rem;min-height:1.6rem;box-sizing:border-box;padding-bottom:1rem;position:relative;background:#fff;border-radius:.3rem;overflow:hidden;position:fixed;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);z-index:9998}';
    beforeCloseActionStyle.innerHTML += '.beforeCloseAction .beforeCloseActionPop .beforeCloseActionPop-text{margin: 0.48rem auto;width: 4.46rem;height: 0.84rem;font-family: \'PingFang SC\';font-style: normal;font-weight: 400;font-size: 0.28rem;line-height: 0.42rem;color: #242424;flex: none;order: 0;flex-grow: 0;}';
    beforeCloseActionStyle.innerHTML += '.beforeCloseAction .beforeCloseActionPop .btnbar{position:absolute;bottom:0;left:0;width:100%;height:1rem;display:-webkit-flex;display:flex;align-items:center;border-top:.1px solid #f3f3f3}';
    beforeCloseActionStyle.innerHTML += '.beforeCloseAction .beforeCloseActionPop .btnbar a{text-decoration:none;flex:1;box-sizing:border-box;height:1.12rem;display:-webkit-flex;display:flex;align-items:center;justify-content:center;color:#ba8341;font-size:.3rem;font-weight:700}';
    beforeCloseActionStyle.innerHTML += '.beforeCloseAction .beforeCloseActionPop .btnbar a:first-child{border-right:.1px solid #B68950;}';
    beforeCloseActionStyle.innerHTML += '.beforeCloseAction .beforeCloseActionPop .beforeCloseAction-img{width: 6rem;height: 2.68rem;background: linear-gradient(180deg, #F7F7F7 0%, #FFFFFF 100%);flex: none;order: 1;flex-grow: 0;}';
    const headTag1 = document.head || document.getElementsByTagName('head')[0];
    headTag1.appendChild(beforeCloseActionStyle);
    // 插入弹窗
    const beforeCloseActionDialog = document.createElement('div');
    beforeCloseActionDialog.className = 'beforeCloseAction';
    // 6.0以下需要绑定角色
    let imgVal = 'https://act.xinyue.qq.com/activity/tgclub/10420/e1e2c5d29d2a51b9ec81625e4d283ed5.png';
    let textVal = '退出后可通过搜索活动对应的游戏，进入对应的游戏专区后找到当前活动';
    if (appVersion(['6', '0', '0'])) {
      // 6.0及以上的文案和图片
      imgVal = 'https://act.xinyue.qq.com/activity/tgclub/10420/0d1cbdeef90482fbbaa94b7912a3283a.png';
      textVal = '退出后可通过进入首页的精选活动-更多，找到当前活动';
    } else {
      if (!Vue.prototype.$actInfo?.extendConfig?.forceRole) {
        imgVal = 'https://act.xinyue.qq.com/activity/tgclub/10420/7ea79f66a243752121deabd368f9fa3f.png';
        textVal = '退出后可通过进入权益tab或会员Tab的热门活动，找到当前活动';
      }
    }
    console.log('actInfo.extendConfig', Vue.prototype.$actInfo?.extendConfig?.forceRole);
    beforeCloseActionDialog.innerHTML = `${`${'<div class="beforeCloseActionPop">'
      + '<img class="beforeCloseAction-img" src="'}${imgVal}">`
      + '<p class="beforeCloseActionPop-text">'}${textVal}</p>`
      + '<div class="btnbar">'
      + '<a class="beforeCloseAction-sure" href="javascript:;">知道了</a>'
      + '</div>'
      + '</div>';
    const htmlTag1 = document.getElementsByTagName('html')[0];
    htmlTag1.appendChild(beforeCloseActionDialog);
    beforeCloseActionDialog.getElementsByClassName('beforeCloseAction-sure')[0].onclick = function () {
      //  点击知道了  埋点上报
      if (typeof Vue.prototype?.$storeInstance?._actions?.reportClickRaw[0] === 'function') {
        const params = {
          // ceibaComponentId: `${this.cid}`,
          // ceibaComponentUid: this.uid,
          // ceibaComponentUname: this.uname,
          eventKey: 'dialog_close',
          eventData: {
            stage: 2,
          },
        };
        console.log('reportClickRaw.params', params);
        Vue.prototype?.$storeInstance?._actions?.reportClickRaw[0](params);
        console.log('reportClickRaw.reportFlush', Vue.prototype?.$storeInstance?._actions?.reportFlush);
      }
      setTimeout(() => {
        Vue.prototype?.$storeInstance?._actions?.reportFlush[0]();
        setFrequency();
        beforeCloseActionDialog.style.display = 'none';
        getDevice() === 'android' ? window.Tgclub?.beforeCloseAction('') : window.Tgclub?.beforeCloseAction();
        window.Tgclub?.closePage();
      }, 200);
    };
    console.log('beforeCloseActionDialog.window.CEIBA_ENV', window.CEIBA_ENV);
    if (ast.isAPP() && getFrequency()) {
      addTgclubJsApiCallback('beforeCloseAction');
    }
    // isClose
    const isCloseTgclubTopBar = common.tool.getQueryparams('closeTgclubTopBar');
    if (ast.isAPP() || isCloseTgclubTopBar) {
      return;
    }
    // 插入样式
    const pubTopBarStyle = document.createElement('style');
    pubTopBarStyle.type = 'text/css';
    pubTopBarStyle.innerHTML = '.xy-download{display:-webkit-flex;display:flex}';
    pubTopBarStyle.innerHTML += '.xy-download{-webkit-align-items:center;align-items:center;-webkti-justify-rection:space-between;justify-content:space-between;height:1.2rem;background:#fff;-webkit-box-shadow:0 0 .1rem rgba(0,0,0,.3);box-shadow:0 0 .1rem rgba(0,0,0,.3);padding:0;margin:0;padding:0 .36rem}';
    pubTopBarStyle.innerHTML += '.xy-logo{height:.8rem;width:3.08rem;display:-webkit-flex;display:flex;-webkti-justify-rection:space-between;justify-content:space-between;}';
    pubTopBarStyle.innerHTML += '.xy-logo-title{height:.8rem;width:2.08rem;}';
    pubTopBarStyle.innerHTML += '.xy-logo-business{font-size: 0.32rem;font-weight: 500;}';
    pubTopBarStyle.innerHTML += '.xy-logo-text{font-size: 0.24rem;color: #8E8E93}';
    pubTopBarStyle.innerHTML += '.xy-logo-image{height:.8rem;width:.8rem;background-image:url(https://game.gtimg.cn/images/js/img/tgclub/tgclubLogo.png);background-size:cover;border-radius: 10px;}';
    pubTopBarStyle.innerHTML += '.xy-download-btn{height:.64rem;width:1.8rem;background-color: #D7B386;border-radius: 8px;font-size: 0.24rem;color: #fff;display:-webkit-flex;display:flex;-webkit-align-items:center;align-items:center;justify-content:center;}';
    pubTopBarStyle.innerHTML += '.confirmDialog{display:none;height: 100vh;width: 100%;position:fixed;top:0;left:0;z-index:9999;background:rgba(0,0,0,0.5)}';
    pubTopBarStyle.innerHTML += '.confirmDialog .confirmDialogPop{width:5.2rem;min-height:1.6rem;box-sizing:border-box;padding-bottom:1rem;position:relative;background:#fff;border-radius:.3rem;overflow:hidden;text-align:center;position:fixed;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);z-index:9998}';
    pubTopBarStyle.innerHTML += '.confirmDialog .confirmDialogPop .confirmDialogPop-text{width:100%;height:1.6rem;display:-webkit-flex;display:flex;align-items:center;justify-content:center;color:#000;font-size:.26rem}';
    pubTopBarStyle.innerHTML += '.confirmDialog .confirmDialogPop .btnbar{position:absolute;bottom:0;left:0;width:100%;height:1rem;display:-webkit-flex;display:flex;align-items:center;border-top:.1px solid #f3f3f3}';
    pubTopBarStyle.innerHTML += '.confirmDialog .confirmDialogPop .btnbar a{text-decoration:none;flex:1;box-sizing:border-box;height:1rem;display:-webkit-flex;display:flex;align-items:center;justify-content:center;color:#000;font-size:.26rem;font-weight:700}';
    pubTopBarStyle.innerHTML += '.confirmDialog .confirmDialogPop .btnbar a:first-child{border-right:.1px solid #f3f3f3}';
    pubTopBarStyle.innerHTML += '.confirmDialog .confirmDialogPop .btnbar .btn-sure{color:#616f89}';

    const headTag = document.head || document.getElementsByTagName('head')[0];
    headTag.appendChild(pubTopBarStyle);
    // 插入结构
    const pubTopBar = document.createElement('div');
    pubTopBar.className = 'xy_topbar';
    pubTopBar.innerHTML = '<div class=\'xy-download\'><div class=\'xy-logo\'><div class=\'xy-logo-image\'></div>'
      + '<div class=\'xy-logo-title\'><p class=\'xy-logo-business\'>心悦俱乐部</p><p class=\'xy-logo-text\'>腾讯游戏福利平台</p></div></div>'
      + '<a class=\'xy-download-btn\' href=\'javascript:;\'>立即打开</a></div>';
    const bodyTag = document.getElementsByTagName('body')[0];
    if (getUrlVars(oUrl).site === 'bot') {
      bodyTag.append(pubTopBar);
    } else {
      bodyTag.prepend(pubTopBar);
    }
    // 插入弹窗
    const confirmDialog = document.createElement('div');
    confirmDialog.className = 'confirmDialog';
    confirmDialog.innerHTML = '<div class="confirmDialogPop">'
      + '<p class="confirmDialogPop-text">下载心悦俱乐部App，参与活动吧！</p>'
      + '<div class="btnbar">'
      + '<a class="btn-cancle" href="javascript:;">取消</a>'
      + '<a class="btn-sure" href="javascript:;">确定</a>'
      + '</div>'
      + '</div>';
    const htmlTag = document.getElementsByTagName('html')[0];
    htmlTag.appendChild(confirmDialog);
    if (typeof Vue.prototype?.$storeInstance?._actions?.reportClickRaw[0] === 'function') {
      const params = {
        // ceibaComponentId: `${this.cid}`,
        // ceibaComponentUid: this.uid,
        // ceibaComponentUname: this.uname,
        eventKey: 'topbar_expose',
      };
      console.log('reportClickRaw.params', params);
      Vue.prototype?.$storeInstance?._actions?.reportClickRaw[0](params);
      console.log('reportClickRaw.reportFlush', Vue.prototype?.$storeInstance?._actions?.reportFlush);
    }
    window.pubTopBarLock = 'unlock';

    function goAPP() {
      event.preventDefault();
      event.stopPropagation();
      if (window.pubTopBarLock === 'lock') {
        return;
      }
      window.pubTopBarLock = 'lock';
      let url = window.location.href;
      const   traceId = Vue.prototype?.$storeInstance?.getters?.reportExt?.trace_id;
      console.log('traceId in  topbar= ', traceId);
      // 跳转 目标地址url  需要加上url  trace_id
      const traceIdInUrl = common.tool.getQueryparams('trace_id', url) || '';
      if (!traceIdInUrl) {
        url = common.tool.setUrlParam('trace_id', traceId, url);
      }
      url = filterUrlParamsFunc(url);
      // 跳转tgclub:// 最外层协议 需要加上 trace_id
      const schemaUrl = `tgclub://redirect?url=${encodeURIComponent(url)}&share=1&trace_id=${traceId}`;
      const gSUA = navigator.userAgent.toLowerCase();
      const android = gSUA.match(/(android)\s+([\d.]+)/);
      const ios = gSUA.match(/(ipad|iphone|ipod).*os\s([\d_]+)/);
      const isWeixin = gSUA.match(/micromessenger/);
      const isQq = gSUA.match(/QQ\/[0-9]/i);
      // const loadDateTime = Date.now();
      // const iframe = document.createElement('iframe');
      if (gSUA.indexOf('tgclub') === -1) {
        switch (true) {
          case (ios !== null && isWeixin !== null): // ios微信
          {
            // IOS的微信，使用JSAPI唤起
            setTimeout(() => {
              window.WeixinJSBridge.invoke('launchApplication', {
                schemeUrl: schemaUrl,
              }, () => {
              });
            }, 500);
            // 手Q直接跳转
            jumpDownApp(3000);
            break;
          }
          case (ios !== null && isQq !== null): // ios 手Q
          {
            window.location.href = schemaUrl;
            const loadDateTime = Date.now();
            setTimeout(() => {
              const timeOutDateTime = Date.now();
              if (timeOutDateTime - loadDateTime < 1000) {
                jumpDownApp(3000);
              }
            }, 25);
            break;
          }
          case (ios !== null && isQq === null && isWeixin === null): // ios 浏览器
            window.location.href = schemaUrl;
            jumpDownApp(1500);
            break;
          case (android !== null && isWeixin !== null):// 安卓 微信
            // IOS的1微信，使用JSAPI唤起
            setTimeout(() => {
              window.WeixinJSBridge.invoke('launchApplication', {
                schemeUrl: schemaUrl,
              }, () => {
              });
            }, 500);
            // 手Q直接跳转
            jumpDownApp(1500);
            break;
          case (android !== null && isWeixin === null): // 安卓 手Q
          {
            const iframe = document.createElement('iframe');
            iframe.src = schemaUrl;
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
            // 手Q直接跳转
            jumpDownApp(1500);
            break;
          }

          case (android !== null && isQq === null && isWeixin === null): // android 浏览器
          {
            const iframe = document.createElement('iframe');
            iframe.src = schemaUrl;
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
            jumpDownApp(1500);
            break;
          }
          default:
            // alert('仅适用IOS或Android')
            window.pubTopBarLock = 'unlock';
            break;
        }
      }
    }

    function jumpDownApp(delayTime) {
      setTimeout(() => {
        window.pubTopBarLock = 'unlock';
        confirmDialog.style.display = 'block';
      }, delayTime);
    }

    function downApp() {
      let appDownUrl;
      if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        appDownUrl = 'https://itunes.apple.com/cn/app/%E5%BF%83%E6%82%A6%E4%BF%B1%E4%B9%90%E9%83%A8-%E8%85%BE%E8%AE%AF%E6%B8%B8%E6%88%8F%E7%8E%A9%E5%AE%B6%E7%A6%8F%E5%88%A9%E5%B9%B3%E5%8F%B0/id1156439976?mt=8';
        window.location.href = appDownUrl;
      } else {
        appDownUrl = 'http://dlied5.myapp.com/myapp/6337/tgclub/apk/20200729/cdf9f187052a10bc6109394055721112.apk';
        window.location.href = appDownUrl;
      }
    }

    document.getElementsByClassName('xy-download-btn')[0].onclick = function () {
      goAPP();
      if (typeof Vue.prototype?.$storeInstance?._actions?.reportClickRaw[0] === 'function') {
        const params = {
          // ceibaComponentId: `${this.cid}`,
          // ceibaComponentUid: this.uid,
          // ceibaComponentUname: this.uname,
          eventKey: 'topbar_click',
        };
        console.log('reportClickRaw.params', params);
        Vue.prototype?.$storeInstance?._actions?.reportClickRaw[0](params);
        console.log('reportClickRaw.reportFlush', Vue.prototype?.$storeInstance?._actions?.reportFlush);
      }
    };
    confirmDialog.getElementsByClassName('btn-cancle')[0].onclick = function () {
      confirmDialog.style.display = 'none';
    };
    confirmDialog.getElementsByClassName('btn-sure')[0].onclick = function () {
      downApp();
    };
  },
};
